import { createSlice } from "@reduxjs/toolkit";

const accessToken = localStorage.getItem("access_token");
const refreshToken = localStorage.getItem("refresh_token");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: accessToken
      ? {
          access_token: accessToken,
          refresh_token: refreshToken,
        }
      : null,
    isLoading: false,
    error: null,
    isAuthenticated: !!accessToken,
    isInitialized: false,
  },
  reducers: {
    loginStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      const { access_token, refresh_token, rememberMe } = action.payload;
      state.isLoading = false;
      state.user = action.payload;
      state.isAuthenticated = true;
      state.isInitialized = true;

      localStorage.setItem("access_token", access_token);
      if (rememberMe && refresh_token) {
        localStorage.setItem("refresh_token", refresh_token);
      } else {
        localStorage.removeItem("refresh_token");
      }
    },
    loginFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitialized = true;
    },
    authInitialized(state) {
      state.isLoading = false;
      state.isInitialized = true;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isInitialized = true;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, authInitialized, logout } =
  authSlice.actions;
export default authSlice.reducer;
